import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

const styles = () => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    backgroundColor: '#FFFFFF',
    '-webkit-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    '-moz-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    boxShadow: '0px 0px 3px 0px rgba(0,0,0,0.15)',
  },
});

class SearchResultEmptyPanel extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.row} style={this.props.style}>
        <Typography variant="subheading" style={{ color: '#71737B' }}>該当するアドレスはありません。</Typography>
      </div>
    );
  }
}

SearchResultEmptyPanel.propTypes = {
  style: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SearchResultEmptyPanel);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/panels/SearchResultEmptyPanel.jsx